import { fm } from 'Components/FormatMessage';
import { Container, Item } from 'Components/Grid';
import HistoryRowVerticalItem from 'Components/HistoryRowVerticalItem';
import HistorySection from 'Components/HistorySection';
import { IHistoryContext, withHistoryContext } from 'Containers/FormContextHandler';
import { isNil } from 'Utility/ramdaReplacement';
import * as React from 'react';
import { newButton } from 'Routes/Diagnosis/utils/functions';
import { editHistoryMenuItems } from 'Components/HistoryRowControls/EditHistory/EditHistoryDialog';

const SymptomsDetailsHistory = ({
  documents = [],
  startEdit,
  treatmentPeriod,
}: IHistoryContext & {
  treatmentPeriod: ININMTTreatmentPeriod;
}): React.JSX.Element => {
  const treatmentId = treatmentPeriod?._id;

  const symptomsDetails: ISymptomsDetails = documents.find(
    d => d._type === 'symptomsDetails' && d.treatmentPeriodId === treatmentId,
  );

  return (
    <HistorySection
      headerText={<span style={{ fontSize: '2.2rem' }}>{fm('diagnosis.ninmt.symptomsDetails.title')}</span>}
      hasHistoryRows={false}
      newButton={
        startEdit
          ? newButton(
              'symptomsDetails',
              (e: React.MouseEvent): void => {
                if (!treatmentId) return;
                startEdit(symptomsDetails ?? {}, 'symptomsDetails', { treatmentPeriodId: treatmentId })(e);
              },
              'general.edit',
              undefined,
              true,
              !isNil(((symptomsDetails ?? {}) as IControlProps)._lockedFor) ||
                treatmentPeriod._editing ||
                !treatmentPeriod.date,
              isNil(((symptomsDetails ?? {}) as IControlProps)._lockedFor)
                ? 'diagnosis.ninmt.treatmentPeriodDisabledTooltip'
                : undefined,
              undefined,
              symptomsDetails,
            )
          : undefined
      }
      menuItems={editHistoryMenuItems(symptomsDetails)}
    >
      <Container>
        <Item xs={0} md={3} lg={3} />
        <Item xs={12} md={9} lg={9}>
          <HistoryRowVerticalItem
            header={fm('diagnosis.ninmt.symptomsDetails.symptomsDetails')}
            headerWidth={5}
            value={symptomsDetails && symptomsDetails.symptomsDetails ? symptomsDetails.symptomsDetails : '-'}
          />
        </Item>
      </Container>
    </HistorySection>
  );
};

export default withHistoryContext(SymptomsDetailsHistory);
